import { render, staticRenderFns } from "./TenantAccessManagement.vue?vue&type=template&id=71f5f5aa&scoped=true&"
import script from "./TenantAccessManagement.vue?vue&type=script&lang=js&"
export * from "./TenantAccessManagement.vue?vue&type=script&lang=js&"
import style0 from "./TenantAccessManagement.vue?vue&type=style&index=0&id=71f5f5aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f5f5aa",
  null
  
)

export default component.exports